<template lang="html">
    <div v-el:qi-niu-container>
        <div class="btn btn-default" v-el:qi-niu-button>
            <i class="glyphicon glyphicon-plus"></i>
            <template v-if="options.uptype == 'wenjian'">
            	<span>上传文件</span>
            </template>
            <template v-else>
            	<span>上传图片</span>
            </template>
        </div>
        <template  v-if="options.uptype == 'wenjian'">
        	 <small>(请上传文件)</small>
        </template>
    </div>
</template>
<script>
    import M from '../assets/common.js'
    import C from '../assets/config.js'

    export default{
        props: {
           options: Object
        },
        data: () => ({
            host: C.host,
            domain: C.qiniu.wuyan.domain,
            token: '',
            files: ['http://cdn.staticfile.org/Plupload/2.1.1/plupload.full.min.js', 'http://cdn.staticfile.org/Plupload/2.1.1/moxie.min.js', 'http://cdn.staticfile.org/qiniu-js-sdk/1.0.14-beta/qiniu.js']
        }),
        created (){
            M.loadFiles(this.files);
        },
        ready (){
            this.getToken();
        },
        methods: {
            /***
             *上传图片
             * @param option
             * @param callback {callbackType: //回调类型属于进度回调还是成功回调}
             */
            uploadQNImg: function(){
                const self = this;
                const qiNiuContainer = this.$els.qiNiuContainer;
                const qiNiuButton = this.$els.qiNiuButton;
                const token = this.token;
                const domain = this.domain;
                var Qiniu2 = new QiniuJsSDK();

                var defaultOption = {
                    runtimes: 'html5,flash,html4',      // 上传模式，依次退化
                    browse_button: qiNiuButton,         // 上传选择的点选按钮，必需
                    uptoken : token, // uptoken是上传凭证，由其他程序生成
                    domain: domain,     // bucket域名，下载资源时用到，必需
                    container: qiNiuContainer,             // 上传区域DOM ID，默认是browser_button的父元素
                    get_new_uptoken: false,             // 设置上传文件的时候是否每次都重新获取新的uptoken
                    max_file_size: this.options.max_file_size?this.options.max_file_size:'5mb',             // 最大文件体积限制
//                    flash_swf_url: 'path/of/plupload/Moxie.swf',  //引入flash，相对路径
                    max_retries: 1,                     // 上传失败最大重试次数
                    dragdrop: true,                     // 开启可拖曳上传
                    chunk_size: '4mb',			// 分块上传时，每块的体积
                    auto_start: true,                   // 选择文件后自动上传，若关闭需要自己绑定事件触发上传
                    isCover: false,    					//是否覆盖,默认为不覆盖
                    key: 'unPath',						//默认路径
                    init: {
                        'FilesAdded': function(up, files) {
                            plupload.each(files, function(file) {
                                // 文件添加进队列后，处理相关的事情
                            });
                        },
                        'BeforeUpload': function(up, file) {
                            // 每个文件上传前，处理相关的事情
                        },
                        'UploadProgress': function(up, file) {
                            // 每个文件上传时，处理相关的事情
                            file.callbackType = 'UploadProgress';
                            self.$dispatch('child-qiniu-data', file);
                        },
                        'FileUploaded': function(up, file, info) {
                            // 每个文件上传成功后，处理相关的事情
                            // 其中info是文件上传成功后，服务端返回的json，形式如：
                            // {
                            //    "hash": "Fh8xVqod2MQ1mocfI4S4KpRL6D98",
                            //    "key": "gogopher.jpg"
                            //  }
                            // 查看简单反馈
                            var domain = up.getOption('domain');
                            // var res = parseJSON(info);
                            // var sourceLink = domain + res.key; 获取上传成功后的文件的Url
                            info = JSON.parse(info);
                            info.domain = domain;
                            info.callbackType = 'FileUploaded';
                            self.options.uptype && (info.picType = self.options.uptype);
                            self.$dispatch('child-qiniu-data', info);
                        },
                        'Error': function(up, err, errTip) {
                            console.error("This Qiniu upload is failure");
                            console.error(err);
                            const options = self.options;
                            if(err.code==-600){
                                M.topRightInfoTips({content: '上传大小不能超过'+(options.max_file_size?options.max_file_size:defaultOption.max_file_size)});
                            }
                            //上传出错时，处理相关的事情
                        },
                        'UploadComplete': function() {
                            //队列文件处理完毕后，处理相关的事情
                        },
                        'Key': function(up,file) {
                            // 若想在前端对每个文件的key进行个性化处理，可以配置该函数
                            // 该配置必须要在unique_names: false，save_key: false时才生效
                            const options = self.options;
                            let merchantId = 'wuyuan';
                            let key = options.key ? options.key : defaultOption.key;
                            merchantId = merchantId?merchantId:'888888';
                            key = merchantId + '/' + key;
                            if((!options)||(!options.isCover)){
                                file.name = file.name.replace(/\./, '_'+new Date().getTime()+'.');
                            }
                            key += '/'+file.name;
                            return key
                        }
                    }
                };
                $.extend(defaultOption, this.options);
                const uploader = Qiniu2.uploader(defaultOption);
            },
            getToken (){
                const self = this;
                const URL = this.host + 'wuyan/qiniu/token';
                M.load(URL,'', function(data){
                    self.$set('token', data.token);
                    //TODO
                    setTimeout(function(){
                        self.uploadQNImg();
                    }, 500);
                },'get');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// qiniu.vue?15c3517d